const DIGITS_ONLY = /^\d+$/;

export const WABA_READ_ONLY_FIELDS = [
  { key: 'company_name', label: 'Company Name' },
  { key: 'company_id', label: 'Company ID' },
  { key: 'source', label: 'Source' },
];

export const WABA_EDITABLE_FIELDS = [
  { key: 'app_name', label: 'Display Name', required: true },
  { key: 'wa_phone_number', label: 'Phone Number', required: true, digitsOnly: true },
  { key: 'wa_phone_number_id', label: 'Phone Number ID', required: true, digitsOnly: true },
  { key: 'waba_id', label: 'WABA ID' },
  { key: 'app_id', label: 'App ID', required: true, digitsOnly: true },
  { key: 'app_type', label: 'App Type' },
  { key: 'wa_version', label: 'API Version' },
  { key: 'wa_messaging_product', label: 'Messaging Product' },
  { key: 'wa_recipient_type', label: 'Recipient Type' },
  { key: 'user_access_token', label: 'Access Token', secret: true, placeholder: 'Leave blank to keep unchanged' },
];

export const WABA_APP_TYPES = ['whatsapp', 'gupshup', 'trustsignal'];

export function buildWabaCreateForm() {
  return {
    app_name: '',
    wa_phone_number: '',
    wa_phone_number_id: '',
    waba_id: '',
    app_id: '',
    app_type: 'whatsapp',
    wa_version: 'v18.0',
    wa_messaging_product: 'whatsapp',
    wa_recipient_type: 'individual',
    user_access_token: '',
    is_active: true,
  };
}

export function validateWabaCreateForm(form = {}) {
  const errors = validateWabaProfileForm(form);

  if (!String(form.app_type || '').trim()) {
    errors.app_type = 'App type is required.';
  }
  if (!String(form.user_access_token || '').trim()) {
    errors.user_access_token = 'Access token is required.';
  }

  return errors;
}

export function buildWabaCreatePayload(form = {}) {
  const payload = {
    app_name: String(form.app_name || '').trim(),
    wa_phone_number: String(form.wa_phone_number || '').trim(),
    wa_phone_number_id: String(form.wa_phone_number_id || '').trim(),
    waba_id: String(form.waba_id || '').trim(),
    app_id: String(form.app_id || '').trim(),
    app_type: String(form.app_type || 'whatsapp').trim(),
    user_access_token: String(form.user_access_token || '').trim(),
    is_active: Boolean(form.is_active),
  };

  ['wa_version', 'wa_messaging_product', 'wa_recipient_type'].forEach((key) => {
    const value = String(form[key] || '').trim();
    if (value) {
      payload[key] = value;
    }
  });

  return payload;
}

export function buildWabaProfileForm(app = {}) {
  return {
    app_name: app.app_name || '',
    wa_phone_number: app.wa_phone_number || '',
    wa_phone_number_id: app.wa_phone_number_id || '',
    waba_id: app.waba_id || '',
    app_id: app.app_id || '',
    app_type: app.app_type || '',
    wa_version: app.wa_version || '',
    wa_messaging_product: app.wa_messaging_product || '',
    wa_recipient_type: app.wa_recipient_type || '',
    user_access_token: '',
    is_active: app.is_active === true || app.status === 'active',
  };
}

export function validateWabaProfileForm(form = {}) {
  const errors = {};

  if (!String(form.app_name || '').trim()) {
    errors.app_name = 'Display name is required.';
  }
  if (!String(form.wa_phone_number || '').trim()) {
    errors.wa_phone_number = 'Phone number is required.';
  } else if (!DIGITS_ONLY.test(String(form.wa_phone_number))) {
    errors.wa_phone_number = 'Phone number must contain digits only.';
  }
  if (!String(form.wa_phone_number_id || '').trim()) {
    errors.wa_phone_number_id = 'Phone number ID is required.';
  } else if (!DIGITS_ONLY.test(String(form.wa_phone_number_id))) {
    errors.wa_phone_number_id = 'Phone number ID must contain digits only.';
  }
  if (!String(form.waba_id || '').trim()) {
    errors.waba_id = 'WABA ID is required.';
  }
  if (String(form.app_id || '').trim() && !DIGITS_ONLY.test(String(form.app_id))) {
  errors.app_id = 'App ID must contain digits only.';
}

  return errors;
}

export function buildWabaProfileUpdatePayload(form, originalApp = {}) {
  const payload = {
    current_wa_phone_number_id: originalApp.wa_phone_number_id,
    app_name: String(form.app_name || '').trim(),
    wa_phone_number: String(form.wa_phone_number || '').trim(),
    wa_phone_number_id: String(form.wa_phone_number_id || '').trim(),
    waba_id: String(form.waba_id || '').trim(),
    app_id: String(form.app_id || '').trim(),
    is_active: Boolean(form.is_active),
  };

  ['app_type', 'wa_version', 'wa_messaging_product', 'wa_recipient_type'].forEach((key) => {
    if (form[key] !== undefined && form[key] !== null) {
      payload[key] = String(form[key]).trim();
    }
  });

  if (String(form.user_access_token || '').trim()) {
    payload.user_access_token = String(form.user_access_token).trim();
  }

  return payload;
}

export function getWabaProfileDisplayFields(app = {}) {
  const editable = WABA_EDITABLE_FIELDS.filter(({ key, secret }) => !secret && app[key])
    .map(({ key, label }) => ({ label, value: app[key] }));

  const readOnly = WABA_READ_ONLY_FIELDS.filter(({ key }) => app[key])
    .map(({ key, label }) => ({ label, value: app[key] }));

  return [...editable, ...readOnly];
}
